import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Login from '../views/Login.vue';
import Layout from '../views/Layout.vue';
import MiniUsers from '../views/MiniUsers.vue';
import PlatformUsers from '../views/PlatformUsers.vue';
import Roles from '../views/Roles.vue';
import CsWorkbench from '../views/CsWorkbench.vue';
import FunctionalResults from '../views/FunctionalResults.vue';
import Articles from '../views/Articles.vue';
import Banners from '../views/Banners.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/login', component: Login, meta: { public: true } },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: (to) => {
          const u = store.state.user;
          if (u && u.roleCode === 'CS') {
            return '/cs';
          }
          return '/mini-users';
        }
      },
      {
        path: 'mini-users',
        name: 'MiniUsers',
        component: MiniUsers,
        meta: { roles: ['ADMIN'] }
      },
      {
        path: 'platform-users',
        name: 'PlatformUsers',
        component: PlatformUsers,
        meta: { roles: ['ADMIN'] }
      },
      { path: 'roles', name: 'Roles', component: Roles, meta: { roles: ['ADMIN'] } },
      {
        path: 'functional-results',
        name: 'FunctionalResults',
        component: FunctionalResults,
        meta: { roles: ['ADMIN'] }
      },
      {
        path: 'articles',
        name: 'Articles',
        component: Articles,
        meta: { roles: ['ADMIN'] }
      },
      {
        path: 'banners',
        name: 'Banners',
        component: Banners,
        meta: { roles: ['ADMIN'] }
      },
      { path: 'cs', name: 'Cs', component: CsWorkbench, meta: { roles: ['ADMIN', 'CS'] } }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.public) {
    return next();
  }
  if (!store.state.token) {
    return next('/login');
  }
  if (!store.state.user) {
    try {
      await store.dispatch('loadMe');
    } catch (e) {
      store.commit('CLEAR_AUTH');
      return next('/login');
    }
  }
  const need = to.meta.roles;
  if (need && need.length) {
    const rc = store.state.user && store.state.user.roleCode;
    if (!need.includes(rc)) {
      return next('/cs');
    }
  }
  next();
});

export default router;
